import { InfoObjective } from "@/models/objective.model";
import { BehaviorSubject } from "rxjs";

class InfoObjectiveService {
  private static info$ = new BehaviorSubject(new InfoObjective());
  static info = this.info$.asObservable();

  static setInfoObjective(data: any): void {
    const info = new InfoObjective();
    info.id = data.id;
    info.name = data.name;
    info.description = data.description;
    info.learningObjective = data.learningObjective;
    info.required = data.required;
    this.info$.next(info);
  }
}

export { InfoObjectiveService };
